/* post-t7-1, Bloque C2: "1 correcta de 5 preguntas" y "... de 1 pregunta". La frase de los resultados de Estudio
   Adaptativo y del Simulador de Examen decia "1 correctas" y "de 1 preguntas". Nacen sus hermanas en singular (Anexo
   C, derivadas): `<base>_una` (una correcta, varias preguntas), `<base>_una_de_una` (una y una) y `<base>_de_una` (una
   sola pregunta y otra cuenta de correctas). Con varias de las dos, la llave de siempre.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos). */

/** `base` es la llave de siempre (por ejemplo `study:adaptive.summary.score_subtitle`). */
export function subtituloDelPuntaje(t, base, correctas, total) {
  const c = Number(correctas) || 0;
  const n = Number(total) || 0;
  let llave = base;
  if (c === 1 && n === 1) llave = `${base}_una_de_una`;
  else if (c === 1) llave = `${base}_una`;
  else if (n === 1) llave = `${base}_de_una`;
  return t(llave, { correct: correctas, total });
}
